import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

export function CategoryFilter({ categories, selectedCategory, onSelectCategory }: CategoryFilterProps) {
  const handleKeyDown = (e: React.KeyboardEvent, category: string | null) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelectCategory(category);
    }
  };

  return (
    <div className="flex flex-wrap gap-2 justify-center" role="group" aria-label="Filtrar posts por categoria">
      <Badge
        variant={selectedCategory === null ? "default" : "outline"}
        className={cn(
          "cursor-pointer transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-kopf-accent focus:ring-offset-2",
          selectedCategory === null 
            ? "bg-kopf-accent text-white hover:bg-kopf-accent/90" 
            : "border-kopf-secondary hover:border-kopf-accent"
        )}
        onClick={() => onSelectCategory(null)}
        onKeyDown={(e) => handleKeyDown(e, null)}
        tabIndex={0}
        role="button"
        aria-pressed={selectedCategory === null}
      >
        Todos
      </Badge>
      {categories.map((category) => (
        <Badge
          key={category}
          variant={selectedCategory === category ? "default" : "outline"}
          className={cn(
            "cursor-pointer transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-kopf-accent focus:ring-offset-2",
            selectedCategory === category 
              ? "bg-kopf-accent text-white hover:bg-kopf-accent/90" 
              : "border-kopf-secondary hover:border-kopf-accent"
          )}
          onClick={() => onSelectCategory(category)}
          onKeyDown={(e) => handleKeyDown(e, category)}
          tabIndex={0}
          role="button"
          aria-pressed={selectedCategory === category}
        >
          {category}
        </Badge>
      ))}
    </div>
  );
}
